module.exports = __webpack_public_path__ + "assets/img/dbdx.44e19747.png";